import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';

import SystemDesignDemo from '../../blocks/SystemDesignDemo';
import MainContainer from '../MainContainer';
import B01home from '../../blocks/B01home';
import B02editos from '../../blocks/B02editos';
import B04fede from '../../blocks/B04fede';
import B18ourpurpose from '../../blocks/B18ourpurpose';
import B05elections from '../../blocks/B05elections';
import B05elections2 from '../../blocks/B05elections2';
import B15congress from '../../blocks/B15congress';
import B15congress2 from '../../blocks/B15congress2';
import B17week from '../../blocks/B17week';
import B06climate from '../../blocks/B06climate';
import B07climate2 from '../../blocks/B07climate2';
import B08recycling from '../../blocks/B08recycling';
import B09housing from '../../blocks/B09housing';
import B10hneed from '../../blocks/B10hneed';
import B10hneed2 from '../../blocks/B10hneed2';
import B11movementhlm from '../../blocks/B11movementhlm';
import B12tranquilityhlm from '../../blocks/B12tranquilityhlm';
import B19overseas from '../../blocks/B19overseas';
import B19overseas2 from '../../blocks/B19overseas2';
import B14research from '../../blocks/B14research';
import B14research2 from '../../blocks/B14research2';
import B20commissions from '../../blocks/B20commissions';
import B21keydigits from '../../blocks/B21keydigits';
import B21keydigits2 from '../../blocks/B21keydigits2';
import B22prodays from '../../blocks/B22prodays';
import B23legaltax from '../../blocks/B23legaltax';
import B24europa from '../../blocks/B24europa';
import B25thanks from '../../blocks/B25thanks';
import B26notebooks from '../../blocks/B26notebooks';

import '../../res/fonts/VinceHand/vinceHand2_15.woff';
import '../../res/fonts/VinceHand/vinceHand2_15.woff2';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/700.css';

import '@fontsource/prata/400.css';

import theme from '../../utils/theme';
import debounce from '../../utils/Debounce';
import refreshIndex from './IndexData';

const BASE_URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? '' : process.env.PUBLIC_URL;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      error: null,
      popupsState: {},
      index: [],
      maxScroll: 100,
      scroll: 0,
    };
    this.onPopup = this.onPopup.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = debounce(this.onResize.bind(this), 300).bind(this);
  }

  componentDidMount() {
    fetch('./data.json', { cache: 'no-store' })
      .then(r => r.text())
      .then(json => {
        try {
          const data = JSON.parse(json);
          const index = refreshIndex(data.index);
          this.setState({ data, index }, () => {
            window.addEventListener('resize', () => this.onResize(true));
            this.onResize(false);
          });
        } catch (error) {
          this.setState({ error });
        }
      });
  }

  onScroll(value) {
    const { maxScroll } = this.state;
    if (value > 0) {
      this.setState({ scroll: 0, popupsState: {} });
    } else if (value < -maxScroll) {
      this.setState({ scroll: -maxScroll, popupsState: {} });
    } else {
      this.setState({ scroll: value, popupsState: {} });
    }
  }

  onResize(forceRefresh) {
    let maxScroll;
    const container = document.querySelector('.scroll-horizontal > div');
    if (container) {
      maxScroll = container.clientWidth - window.innerWidth;
    }
    this.setState(prev => ({
      index: forceRefresh ? refreshIndex(prev.data.index) : prev.index,
      maxScroll: maxScroll || prev.maxScroll,
    }));
  }

  renderError() {
    const { error } = this.state;
    if (!error) {
      return null;
    }
    return (
      <div style={{ padding: 30 }}>
        <h2>Erreur dans le parsing du fichier</h2>
        <pre>{error.message}</pre>
      </div>
    );
  }

  renderLoading() {
    const { data, error } = this.state;
    if (data || error) {
      return null;
    }
    return (
      <div style={{ width: '100%', paddingTop: '35vh', textAlign: 'center' }}>
        <h1 style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>Chargement...</h1>
        <CircularProgress />
      </div>
    );
  }

  onPopup(id, state) {
    this.setState(prev => ({ popupsState: { ...prev.popupsState, [id]: state } }));
  }

  renderApp() {
    const { data, error, popupsState, index, maxScroll, scroll } = this.state;
    if (!data || error) {
      return null;
    }
    if (data.demo === 'true') {
      return <SystemDesignDemo data={data} baseUrl={BASE_URL} />;
    }
    return (
      <MainContainer
        data={data}
        onPopup={this.onPopup}
        index={index}
        maxScroll={maxScroll}
        scroll={scroll}
        onScroll={this.onScroll}
      >
        <B01home
          blockData={data.blocks.b01home}
          common={data.common}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B02editos
          blockData={data.blocks.b02emmanuellecosse}
          popupData={data.popups.emmanuelleCosse}
          popupItvData={data.popups.emmanuelleCosseItv}
          baseUrl={BASE_URL}
          frame="orange"
          color="bluelight"
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B02editos
          blockData={data.blocks.b02mariannelouis}
          popupData={data.popups.marianneLouis}
          popupItvData={data.popups.marianneLouisItv}
          baseUrl={BASE_URL}
          frame="purple"
          color="blueultralight"
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B21keydigits blockData={data.blocks.b21keydigits} common={data.common} baseUrl={BASE_URL} />
        <B21keydigits2 blockData={data.blocks.b21keydigits2} common={data.common} baseUrl={BASE_URL} />
        <B04fede
          blockData={data.blocks.b04federations}
          popupFedeOPHData={data.popups.fedeOPH}
          popupFedeESHData={data.popups.fedeESH}
          popupFedeCoopData={data.popups.fedeCoop}
          popupFedeFNARData={data.popups.fedeFNAR}
          popupFedeProcivisData={data.popups.fedeProcivis}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B05elections
          blockData={data.blocks.b05elections}
          popupUsefulTogetherData={data.popups.usefulTogether}
          popupAllianceData={data.popups.alliance}
          popupCommunicationData={data.popups.communication}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B05elections2
          blockData={data.blocks.b05elections2}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupAllianceData={data.popups.alliance}
        />
        <B15congress
          blockData={data.blocks.b15congress}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B15congress2
          blockData={data.blocks.b15congress2}
          popupSeqCongressData={data.popups.seqcongress}
          popupDigitalCongressData={data.popups.digitalcongress}
          popupReportCongressData={data.popups.reportcongress}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B17week
          blockData={data.blocks.b17week}
          baseUrl={BASE_URL}
          popupEventHlmData={data.popups.eventHlm}
          popupPortraitHlmData={data.popups.portraitHlm}
          popupHlmSurCourtData={data.popups.hlmSurCourt}
          popupEmissionData={data.popups.emission}
          popupTrophiesData={data.popups.trophies}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B22prodays
          blockData={data.blocks.b22prodays}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupProdaysData={data.popups.prodays}
        />
        <B26notebooks
          blockData={data.blocks.b26notebooks}
          baseUrl={BASE_URL}
          popupActsData={data.popups.acts}
          popupSignetData={data.popups.signet}
          popupPinsData={data.popups.pins}
          popupReferenceData={data.popups.reference}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B06climate
          blockData={data.blocks.b06climate}
          popupDPEData={data.popups.dpe}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B07climate2
          blockData={data.blocks.b07climate2}
          popupBioData={data.popups.bio}
          popupElecData={data.popups.elec}
          popupGoData={data.popups.go}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B08recycling
          blockData={data.blocks.b08recycling}
          popupZANData={data.popups.zan}
          popupFoncierData={data.popups.foncier}
          popupNPNRUData={data.popups.npnru}
          popupSocialUnionData={data.popups.socialUnion}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B09housing
          blockData={data.blocks.b09housing}
          popupHousequalityData={data.popups.houseQuality}
          popupMaterialData={data.popups.material}
          popupGazPriceData={data.popups.gazPrice}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B10hneed
          blockData={data.blocks.b10hneed}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B10hneed2
          blockData={data.blocks.b10hneed2}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupLoisData={data.popups.lois}
          popupObservatoryData={data.popups.observatory}
          popupReformData={data.popups.reform}
          popupSocialemergencyData={data.popups.socialemergency}
          popupAgingData={data.popups.aging}
          popupYouthhousingData={data.popups.youthhousing}
        />
        <B11movementhlm
          blockData={data.blocks.b11movementhlm}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupQualiHlmData={data.popups.qualihlm}
          popupSatisfsurveyData={data.popups.satisfsurvey}
          popupHealthcrisisData={data.popups.healthcrisis}
        />
        <B12tranquilityhlm
          blockData={data.blocks.b12tranquilityhlm}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupViolencewomanhlmData={data.popups.violencewomanhlm}
          popupSecurityhlmData={data.popups.securityhlm}
        />
        <B24europa blockData={data.blocks.b24europa} baseUrl={BASE_URL} />
        <B19overseas
          blockData={data.blocks.b19overseas}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupUltramarinerealData={data.popups.ultramarinereal}
          popupMultiannuallawData={data.popups.multiannuallaw}
        />
        <B19overseas2
          blockData={data.blocks.b19overseas2}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupUltramarineterritoryData={data.popups.ultramarineterritory}
          popupDROMhousingData={data.popups.dromhousing}
          popupNewgenfundingData={data.popups.newgenfunding}
          popupMartiniquehousingData={data.popups.martiniquehousing}
        />
        <B23legaltax
          blockData={data.blocks.b23legaltax}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupLegaltaxData={data.popups.legaltax}
        />
        <B14research
          blockData={data.blocks.b14research}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
          popupResearchWorkData={data.popups.researchWork}
        />
        <B14research2
          blockData={data.blocks.b14research2}
          baseUrl={BASE_URL}
          popupResearchProgramData={data.popups.researchProgram}
          popupResearchPriceData={data.popups.researchPrice}
          popupResearchPanoramaData={data.popups.researchPanorama}
          popupResearchRoomMateData={data.popups.researchRoomMate}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B20commissions
          blockData={data.blocks.b20commissions}
          baseUrl={BASE_URL}
          popupCommiattributionData={data.popups.commiattribution}
          popupCommiqualityData={data.popups.commiquality}
          popupCommisecujobData={data.popups.commisecujob}
          popupCommiterritoriesData={data.popups.commiterritories}
          popupCommitransitionparkData={data.popups.commitransitionpark}
          popupCommiaccessionData={data.popups.commiaccession}
          popupCommiecoforsightData={data.popups.commiecoforsight}
          popupCommibusinessnetData={data.popups.commibusinessnet}
          popupsState={popupsState}
          onPopup={this.onPopup}
          onScroll={this.onScroll}
          index={index}
        />
        <B18ourpurpose
          blockData={data.blocks.b18ourpurpose}
          baseUrl={BASE_URL}
          popupsState={popupsState}
          onPopup={this.onPopup}
        />
        <B25thanks blockData={data.blocks.b25thanks} common={data.common} baseUrl={BASE_URL} />
      </MainContainer>
    );
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {this.renderLoading()}
        {this.renderError()}
        {this.renderApp()}
      </ThemeProvider>
    );
  }
}

export default App;
